import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronLeft = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.9396 5.93933L28.0609 8.06065L16.1215 20L28.0609 31.9393L25.9396 34.0606L11.8789 20L25.9396 5.93933Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronLeft.propTypes = {onClick: PropTypes.func}

export default ChevronLeft
